export default __webpack_public_path__ + "static/media/node.a8c363ae.png";